import { render, staticRenderFns } from "./selectCallCenter.vue?vue&type=template&id=2077e538"
import script from "./selectCallCenter.vue?vue&type=script&lang=ts"
export * from "./selectCallCenter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports